import { LiveStreamResolutionEnum } from "../types/models";

const RANK: Record<LiveStreamResolutionEnum, number> = {
  [LiveStreamResolutionEnum.r1080p]: 1,
  [LiveStreamResolutionEnum.r2160p]: 2,
};

/** True when the API classified the file above the stream's tier (e.g. 4K file on a 1080p stream). */
export function exceedsStreamTier(
  item: { resolutionTier?: LiveStreamResolutionEnum | null },
  streamResolution: LiveStreamResolutionEnum,
): boolean {
  if (!item.resolutionTier) return false;
  return RANK[item.resolutionTier] > RANK[streamResolution];
}

export type LibraryGateReason = "none" | "probe-pending" | "probe-failed" | "unsupported" | "tier-mismatch";

/** Probe failures are stored as error codes; resolution refusals are sentences. */
export function isProbeFailure(resolutionError?: string | null): boolean {
  return !!resolutionError && /^[A-Z][A-Z0-9_]*$/.test(resolutionError);
}

/** UC-5.12/5.11: one gate for single and bulk adds. A lower tier always fits a higher stream. */
export function libraryGateReason(
  item: {
    resolutionTier?: LiveStreamResolutionEnum | null;
    resolutionError?: string | null;
    key?: string;
    url?: string;
    importLoading?: boolean;
  },
  isVideo: boolean,
  streamResolution: LiveStreamResolutionEnum,
  allowPendingPrimaryUpload = false,
): LibraryGateReason {
  if (!isVideo) return "none";
  if (item.resolutionTier == null) {
    if (!item.resolutionError) {
      return allowPendingPrimaryUpload &&
        !item.importLoading &&
        !!item.key?.trim() &&
        !!item.url?.trim()
        ? "none"
        : "probe-pending";
    }
    return isProbeFailure(item.resolutionError) ? "probe-failed" : "unsupported";
  }
  return exceedsStreamTier(item, streamResolution) ? "tier-mismatch" : "none";
}
